// extracted by mini-css-extract-plugin
var _1 = "CVNJH3";
var _2 = "YUfqR3";
var _3 = "swRC1O";
var _4 = "a_Hs20";
var _5 = "apYk65";
var _6 = "dJetY7";
var _7 = "AYXn3M";
var _8 = "CnffYn";
var _9 = "gN05dW";
var _a = "_d4zhe";
var _b = "SNQPfl";
var _c = "bI486N";
var _d = "Uut2UK";
var _e = "HwK81h";
var _f = "RD9fPs";
var _10 = "N6eunw";
var _11 = "nDOgB1";
export { _1 as "disabled", _2 as "ease-transition", _3 as "gradient-titanic-80", _4 as "knob", _5 as "linear-transition-05", _6 as "primary", _7 as "secondary", _8 as "shadow-medium-titanic", _9 as "shadow-medium-titanic-hover", _a as "shadow-titanic-1", _b as "shadow-white", _c as "size-24", _d as "size-32", _e as "size-40", _f as "size-64", _10 as "size-72", _11 as "white" }
